<template>
  <b-container class="my-5">
    <b-row>
      <b-col xl="12">
        <b-card no-body>
          <h3 class="card-header bg-white">Entrar a
            <b>Listado Médico</b>
            <small class="d-block" style="font-size: 65%">Regresar al
              <b-link class="card-link" href="/">sitio web</b-link>.
            </small>
          </h3>
          <b-card-body>
            <b-row>
              <b-col xl="6">
                <b-form @submit="onSubmit" @reset="onReset">
                  <b-form-group
                    id="label-email"
                    label="Email"
                    label-for="email">
                    <b-input-group prepend="@">
                      <b-form-input id="email" v-model="form.data.email" placeholder="Email" trim />
                    </b-input-group>
                  </b-form-group>
                  <b-form-group
                    id="label-password"
                    label="Password"
                    label-for="password">
                    <b-input-group>
                      <template v-slot:prepend>
                        <b-input-group-text >
                          <font-awesome-icon :icon="['fas','key']"/>
                        </b-input-group-text>
                      </template>
                      <b-form-input type="password" id="password" v-model="form.data.password" placeholder="Password" trim />
                    </b-input-group>
                  </b-form-group>
                  <b-form-group>
                    <div id="recaptcha" class="g-recaptcha" :data-sitekey="rcapt_sig_key"></div>
                  </b-form-group>
                  <b-form-group>
                    <div class="checkbox">
                      <b-form-checkbox
                        id="remember"
                        v-model="form.data.remember"
                        name="remember"
                        value="true">
                        Recordarme
                        <small class="text-muted">Sólo en dispositivos personales.</small>
                      </b-form-checkbox>
                    </div>
                  </b-form-group>
                  <b-button variant="success" type="submit" value="signup" name="submit">Entrar</b-button>
              </b-form>
            </b-col>
            <b-col xl="6">
              <h4>Regístrese ahora
                <span class="text-success"> es gratis!</span>
              </h4>
              <ul class="list-unstyled" style="line-height: 2">
                <li>
                  <font-awesome-icon :icon="['fas','check']" class="text-success"/>
                  Su perfil profesional en linea
                </li>
                <li>
                  <font-awesome-icon :icon="['fas','check']" class="text-success"/>
                  Sus consultorio geolocalizados
                </li>
                <li>
                  <font-awesome-icon :icon="['fas','check']" class="text-success"/>
                  Acepte citas desde la web
                </li>
                <li>
                  <font-awesome-icon :icon="['fas','check']" class="text-success"/>
                  Administre su agenda de citas online
                </li>
                <li>
                  <font-awesome-icon :icon="['fas','check']" class="text-success"/>
                  Sincronize sus citas con su calendario de Google
                </li>
              </ul>
              <div class="fixed-bottom" style="position: absolute; padding: 0 15px 0 12px;">
                <b-link class="bottom btn btn-primary" to="/signup">Registrarme</b-link>
              </div>
            </b-col>
          </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col xl="12">
        <adsense
          ad-slot="9585150092"
          ad-format="auto"
          ad-client="ca-pub-1844310477126911"
          ad-style="display:block">
        </adsense>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Adsense from '@/components/Adsense'

export default {
  components: { Adsense },
  name: 'Signin',
  data () {
    return {
      rcapt_sig_key: process.env.VUE_APP_RECAPTCHA_API_KEY,
      rcapt_id: '',
      form: {
        data: {
          email: '',
          password: '',
          remember: false
        }
      }
    }
  },
  mounted () {
    if (window.grecaptcha) {
      this.rcapt_id = window.grecaptcha.render(
        document.getElementById('recaptcha'),
        { sitekey: this.rcapt_sig_key })
    }
  },
  methods: {
    onSubmit: async function (event) {
      event.preventDefault()
      this.form.data.g_recaptcha_response = window.grecaptcha.getResponse(this.rcapt_id)
      try {
        const response = await this.$http.post('/signin', this.form.data)
        this.$store.commit('setDoctor', response.data)
        this.$router.push('/offices')
      } catch (error) {
        const err = error.response.data.errors[0]
        this.$bvToast.toast(err.message, {
          title: 'Error iniciando sesión',
          autoHideDelay: 5000
        })
        window.grecaptcha.reset()
      }
    },
    onReset: async function (event) {

    }
  }
}
</script>
